export const MYACCOUNT_CONSTANTS: any = {
	analyticsReporting: {
		boolean: {
			'true': 'true',
			'false': 'false'
		},
		dym: {
			auto: 'DYM Auto',
			clicked: 'DYM Clicked'
		},
		pageType: {
			'home': 'Home',
			'category': 'Category',
			'family': 'Family',
			'search': 'Search',
			'product': 'Product Details',
			'cart': 'Cart',
			'checkout': 'Checkout',
			'order.confirmation': 'OrderConfirmation'
		},
		replacementType: {
			addition: 'Addition',
			replacement: 'Replacement'
		},
		searchEmptyResults: {
			recordSetTotal: '',
			catalogEntryView: [],
			searchDetails: {
				DYMTerm: '',
				DYMType: '',
				searchTerm: '',
				replacementTerm: '',
				searchType: ''
			}
		},
		searchType: {
			keyword: 'Keyword',
			suggestedKeyword: 'Suggested Keyword',
			suggestedProduct: 'Suggested Product',
			suggestedBrand: 'Suggested Brand',
			pdpBrandClick: 'PDP Brand Click',
			suggestedResources: 'Suggested Resources',
			suggestedHistory: 'Suggested History',
			suggestedCategory: 'Suggested Category',
			searchByProductID: 'Search by ProductID',
			redirect: 'Redirect'
		}
	},
	attributes: {
		identifiers: {
			badge: '4298',
			freeReturnsEligible: '4493'
		}
	},
	cookies: {
		auth: {
			expiration: {
				value: 30,
				unit: 'days'
			}
		}
	},
	defaultCurrency: 'USD',
	defaultStoreSearchRadius: 50,
	guestUserId: '-1002',
	maxApiRetries: 3,
	product: {
		maxQuantity: 99
	},
	paginationSize: {
		familyAndSearch: 48
	},
	refreshAddToCartTimeout: 20000,
	xProperties: {
		groupingLogicEnable: 'GROUPINGLOGIC_ENABLED'
	},
	basePath: 'dcsg-ngx-header',
	searchMaxLength: 75,
	searchDex: {
		gatewayUrlProxy: {
			browser: `/products/includes/`,
			server: `http://localhost:8080/dcsg-ngx-header/sdxincludes/api/`
		},
		dsg: {
			baseUrl: 'https://www.dickssportinggoods.com/products/includes/'
		},
		gg: {
			baseUrl: 'https://www.golfgalaxy.com/products/includes/'
		},
		pl: {
			baseUrl: 'https://www.publiclands.com/products/includes/'
		}
	},
	headerVersion: '07.22.2020',
	storeNumberUrl: 'https://ngstorelocationlb.dcsg.com/NGStoreLocationWS/StoreLocationLookup.svc/json/GetStoreInformation',
	homr: {
		acceptedHeaders: [
			'audience',
			'previewdate',
			'draft',
			'preview'
		],
		globalElements: [
			'disruptor',
			'ticker',
			'header',
			'footer'
		],
		previewKey: 'williamgoats'
	},

	rewardsDisclaimer: {
		dsg: {
			text: `
				Points scored for in-store purchases are available the day after you purchase.
				Points scored from Dicks.com or purchased through the DICK'S mobile application
				are available the day after the final item in your order ships. Bonus points
				scored from DICK's Sporting Goods Credit Card purchases will be available after
				your billing statement cycle. Bonus points earned with Move are available the
				day after you meet your activity goal.
			`
		},
		gg: {
			text: `
				Points scored for in-store purchases are available the day after you purchase.
				Points scored from Dicks.com or purchased through the DICK'S mobile application
				are available the day after the final item in your order ships. Bonus points
				scored from DICK's Sporting Goods Credit Card purchases will be available after
				your billing statement cycle. Bonus points earned with Move are available the
				day after you meet your activity goal.
			`
		},
		pl: {
			text: 'Points earned for in-store purchases are available the day after you purchase. Points earned for PublicLands.com purchases are available the day after the final item in your order ships.'
		}
	},
	forgotLoyaltyCardText: {
		dsg: 'Forgot to use your ScoreCard?',
		gg: 'Forgot to use your ScoreCard?',
		g3: 'Forgot to use your ScoreCard?',
		pl: 'Forgot to use your Public Lands HUB Account?'
	},
	favoritesPath: '/MyAccount/Favorites',
	listsPath: '/MyAccount/Lists',
	appointmentsPath: '/MyAccount/Appointments',
	unAuthenticatedAppPaths: [
		'/TrackOrder',
		'/CompleteProfile'
	]
};
